import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import buildLinkObj, { getRel } from '@repo/ui/src/functions/build-link';
import Image from 'next/image';
import { GeneralBodyProps } from '@components/GeneralBody';
import { AnchorProps } from '@repo/ui/src/components/Anchor';

const ErrorBody = ({ body }: GeneralBodyProps) => {
  const errorBody = body[0];

  return (
    <div className="tw-px-8 tw-py-8 sm:tw-px-12 sm:tw-py-12 tw-m-auto tw-max-w-smallBody">
      <h1 className="tra-text-web-heading-4 tw-text-center tw-mb-10">
        {errorBody?.title || 'Page Not Found'}
      </h1>
      <div className="tw-flex tw-flex-col sm:tw-flex-row tw-justify-center">
        <div className="tw-flex tw-flex-1 tw-justify-center tw-mb-2">
          {errorBody?.image && (
            <Image
              src={buildImageSrc(errorBody?.image, 450, 1, 1)}
              alt="404 Image"
              width={450}
              height={450}
              style={{ width: '100%', height: 'auto' }}
            />
          )}
        </div>
        <div className="tw-flex-1 sm:tw-pl-5">
          {errorBody?.description && <p className="tw-mb-4">{errorBody?.description}</p>}
          <ul className="tw-list-none">
            {errorBody?.links &&
              errorBody?.links.map((link: AnchorProps, i: number) => {
                const linkObj = buildLinkObj(link);
                return (
                  <li key={`404Link_${i}`}>
                    <a rel={getRel(linkObj)} href={linkObj.href} className="tw-underline">
                      {linkObj.text}
                    </a>
                  </li>
                );
              })}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ErrorBody;
